import ProductIcon from "@mui/icons-material/Collections";
import ProductCreate from "./ProductCreate";
import ProductEdit from "./ProductEdit";
import ProductList from "./ProductList";

export default {
  list: ProductList,
  create: ProductCreate,
  edit: ProductEdit,
  icon: ProductIcon,
};
